import axios from 'axios';
import apiConfig from '../config/api.config';

const bulletinClient = axios.create({
    baseURL: apiConfig.baseURL,
    timeout: apiConfig.timeout,
    headers: apiConfig.headers
});

const bulletinService = {
    /**
     * E-bülten aboneliği kaydeder
     * @param {string} email - Kullanıcının e-posta adresi
     * @returns {Promise} API response
     */
    async subscribe(email, recaptchaToken = null) {
        const body = {
            email,
            hostName: apiConfig.hostName,
            profix: process.env.REACT_APP_BULLETIN_PREFIX || '',
            isKvkk: true,
            lang: 'tr',
            ...(recaptchaToken && { recaptchaResponse: recaptchaToken }),
        };

        const response = await bulletinClient.post('/v1/api/insert-bulletin-mail', body);
        return response.data;
    }
};

export default bulletinService;